<template>
  <LazyBlogPageLayout hydrate-on-idle path="personal" />
</template>
<script setup lang="ts"></script>
